import { axios } from '@/utils/request'

const api = {
    getMiniCode:'/adminapi/sai/getMiniCodeImg',
    saiquList: '/adminapi/sai/saiquList',
    saiquCashList: '/adminapi/sai/saiquCashList',
    saiquRewardList: '/adminapi/sai/saiquRewardList',
    onSaiReward: '/adminapi/sai/onSaiReward',
    onSaiRewardAll: '/adminapi/sai/onSaiRewardAll',
    cashSaiqu: '/adminapi/sai/cashSaiqu',
    setRewardExtraPrice: '/adminapi/sai/setRewardExtraPrice',
    sjsqOptions: '/adminapi/sai/sjsqOptions',
    saiquOptions: '/adminapi/sai/saiquOptions',

    saiquDetail: '/adminapi/sai/saiquDetail',
    editSaiqu: '/adminapi/sai/editSaiqu',
    deleteSaiqu: '/adminapi/sai/deleteSaiqu',
    addSaiqu: '/adminapi/sai/addSaiqu',

    saijiList: '/adminapi/sai/saijiList',
    saijiDetail: '/adminapi/sai/saijiDetail',
    editSaiji: '/adminapi/sai/editSaiji',

    danweiList: '/adminapi/sai/danweiList',
    danweiUserList: '/adminapi/sai/danweiUserList',
    danweiOptions: '/adminapi/sai/danweiOptions',
    danweiDetail: '/adminapi/sai/danweiDetail',
    editDanwei: '/adminapi/sai/editDanwei',
    addDanweiUser: '/adminapi/sai/addDanweiUser',
    danweiDelete: '/adminapi/sai/danweiDelete',
    deleteDanweiUser: '/adminapi/sai/deleteDanweiUser',

    applyList: '/adminapi/sai/applyList',
    applyDetail: '/adminapi/sai/applyDetail',
    editApply: '/adminapi/sai/editApply',
    getApplyOrderDetail: '/adminapi/sai/applyOrderDetail',
    editApplyOrder: '/adminapi/sai/editApplyOrder',
    refreshOrder: '/adminapi/sai/refreshOrder',

    applySubjectList: '/adminapi/sai/applySubjectList',
    applySubjectDetail: '/adminapi/sai/applySubjectDetail',
    editApplySubject: '/adminapi/sai/editApplySubject',

    subjectOptions: '/adminapi/sai/subjectOptions',
    downloadAllCpCert: '/adminapi/sai/downloadAllCpCert',
    downloadAllJlCert: '/adminapi/sai/downloadAllJlCert',
    downloadAllLdCert: '/adminapi/sai/downloadAllLdCert',
    downloadAllCert: '/adminapi/sai/downloadAllCert',

    applyDelete: '/adminapi/sai/applyDelete',
    getStartList: '/adminapi/sai/getStartList',
    startListOptions: '/adminapi/sai/startListOptions',
    caipanList: '/adminapi/sai/caipanList',
    setYouxiu: '/adminapi/sai/setYouxiu',
    jiaolianList: '/adminapi/sai/jiaolianList',
    lingduiList: '/adminapi/sai/lingduiList',


    subjectMusicList: '/adminapi/sai/subjectMusicList',
    subjectMusicDetail: '/adminapi/sai/subjectMusicDetail',
    editSubjectMusic: '/adminapi/sai/editSubjectMusic',
    addSubjectMusic: '/adminapi/sai/addSubjectMusic',
    subjectMusicDelete: '/adminapi/sai/subjectMusicDelete',



    subjectTypeList: '/adminapi/sai/subjectTypeList',
    subjectTypeDetail: '/adminapi/sai/subjectTypeDetail',
    editSubjectType: '/adminapi/sai/editSubjectType',
    addSubjectType: '/adminapi/sai/addSubjectType',
    subjectTypeDelete: '/adminapi/sai/subjectTypeDelete',


    subjectMemberLimitList: '/adminapi/sai/subjectMemberLimitList',
    setSubjectMemberLimit: '/adminapi/sai/setSubjectMemberLimit',
    setSubjectTbMemberLimit: '/adminapi/sai/setSubjectTbMemberLimit',
    setSubjectAgeLimit: '/adminapi/sai/setSubjectAgeLimit',
    setAgeMixedSubjectLimit: '/adminapi/sai/setAgeMixedSubjectLimit',

    subject2MusicList: '/adminapi/sai/subject2MusicList',
    setSubjectMusicLimit: '/adminapi/sai/setSubjectMusicLimit',
    setSubjectMusic: '/adminapi/sai/setSubjectMusic',
    setSubjectsMusic: '/adminapi/sai/setSubjectsMusic',
    getSubjectTypeOptions: '/adminapi/sai/subjectTypeOptions',
    subjectDelete: '/adminapi/sai/subjectDelete',


    getSaiDateDetail: '/adminapi/sai/getSaiDateDetail',
    getTaskDetail: '/adminapi/sai/getTaskDetail',
    taskEdit: '/adminapi/sai/taskEdit',
    taskAdd: '/adminapi/sai/taskAdd',
    setTaskRank: '/adminapi/sai/setTaskRank',
    taskDelete: '/adminapi/sai/taskDelete',

    addSaiquApply: '/adminapi/sai/addSaiquApply',
    editSaiquApply: '/adminapi/sai/editSaiquApply',
    getSaiquApplyList: '/adminapi/sai/saiquApplyList',
    getSaiquApplyDetail: '/adminapi/sai/saiquApplyDetail',
    editDo: '/adminapi/sai/editDo',


    addSaiFile: '/adminapi/sai/filesadd',
    saiFileList: '/adminapi/sai/fileslist',
    deleteSaiFile: '/adminapi/sai/filesdelete',


    subjectTreeList: '/adminapi/sai/subjectTreeList',
    subjectTplTreeList: '/adminapi/sai/subjectTplTreeList',
    saveSubjectTree: '/adminapi/sai/saveSubjectTree',


    getXieyiList: '/adminapi/sai/xieyiList',
    addXieyiFile: '/adminapi/sai/addXieyiFile',
    saiquApplyDelete: '/adminapi/sai/saiquApplyDelete',



    roomTypeList: '/adminapi/sai/roomTypeList',
    roomTypeDetail: '/adminapi/sai/roomTypeDetail',
    addRoomType: '/adminapi/sai/addRoomType',
    editRoomType: '/adminapi/sai/editRoomType',
    roomTypeDelete: '/adminapi/sai/roomTypeDelete',

    //酒店
    hotelList: '/adminapi/sai/hotelList',
    hotelDetail: '/adminapi/sai/hotelDetail',
    addHotel: '/adminapi/sai/addHotel',
    editHotel: '/adminapi/sai/editHotel',
    hotelDelete: '/adminapi/sai/hotelDelete',

    //交通
    busList: '/adminapi/sai/busList',
    busDetail: '/adminapi/sai/busDetail',
    addBus: '/adminapi/sai/addBus',
    editBus: '/adminapi/sai/editBus',
    busDelete: '/adminapi/sai/busDelete',

    //站点
    stationList: '/adminapi/sai/stationList',
    stationDetail: '/adminapi/sai/stationDetail',
    addStation: '/adminapi/sai/addStation',
    editStation: '/adminapi/sai/editStation',
    stationDelete: '/adminapi/sai/stationDelete',



    getConfrimApplyList: '/adminapi/sai/confrimApplyList',
    getTransApplyList: '/adminapi/sai/transApplyList',
    setConfrimStatus: '/adminapi/sai/setConfrimStatus',
    editTrans: '/adminapi/sai/editTrans',

    hotelOptions: '/adminapi/sai/hotelOptions',
    setHotel: '/adminapi/sai/setHotel',
    unSetHotel: '/adminapi/sai/unSetHotel',
    busgetImport: '/adminapi/sai/busgetImport',
    busgoImport: '/adminapi/sai/busgoImport',
    zhusuImport: '/adminapi/sai/zhusuImport',

    orderRefund: '/adminapi/sai/orderRefund',
    orderRefund2023: '/adminapi/sai/orderRefund2023',
    orderBuRefund: '/adminapi/sai/orderBuRefund',
    orderRefundApply: '/adminapi/sai/orderRefundApply2023',
    orderRefundApply2023: '/adminapi/sai/orderRefundApply2023',
    orderRefundRefuse: '/adminapi/sai/orderRefundRefuse',
    orderRefundRefuse2023: '/adminapi/sai/orderRefundRefuse2023',
    setBuPrice: '/adminapi/sai/setBuPrice',
    buOrderDelete: '/adminapi/sai/buOrderDelete',


    //执行官
    zhixingguanList: '/adminapi/sai/zhixingguanList',
    zhixingguanDetail: '/adminapi/sai/zhixingguanDetail',
    addZhixingguan: '/adminapi/sai/addZhixingguan',
    editZhixingguan: '/adminapi/sai/editZhixingguan',
    zhixingguanDelete: '/adminapi/sai/zhixingguanDelete',

    //cca负责人 
    ccarenList: '/adminapi/sai/ccarenList',
    ccarenDetail: '/adminapi/sai/ccarenDetail',
    addCcaren: '/adminapi/sai/addCcaren',
    editCcaren: '/adminapi/sai/editCcaren',
    ccarenDelete: '/adminapi/sai/ccarenDelete',


    saiquXieyiDelete: '/adminapi/sai/xieyiDelete',


    //裁判库

    memberCaipanList: '/adminapi/sai/memberCaipanList',
    memberCaipanDetail: '/adminapi/sai/memberCaipanDetail',
    editMemberCaipan: '/adminapi/sai/editMemberCaipan',
    addMemberCaipan: '/adminapi/sai/addMemberCaipan',
    memberCaipanDelete: '/adminapi/sai/memberCaipanDelete',

    // 发票
    fapiaoApply: '/adminapi/sai/fapiaoApply',
    getKaipiaoItemList: '/adminapi/sai/getKaipiaoItemList',
    fapiaoShenqingApply: '/adminapi/sai/fapiaoShenqingApply',

    // 批量上传人员
    checkBaomingInfoOk: '/adminapi/sai/checkBaomingInfoOk',
    baomingImport: '/adminapi/sai/baomingImport',

    // 执裁记录
    editScoreCaipanApply: '/adminapi/sai/scoreCaipanApplyEdit',
    scoreCaipanApplyList: '/adminapi/sai/scoreCaipanApplyList',
    scoreCaipanApplyDetail: '/adminapi/sai/scoreCaipanApplyDetail',
    saiquRewardsSetting: '/adminapi/sai/saiquRewardsSetting',


    cashDetail: '/adminapi/sai/saiRewardDetail',
    cashEdit: '/adminapi/sai/saiRewardEdit',

    addAdminUser: '/adminapi/sai/addAdminUser',
    deleteAdminUser: '/adminapi/sai/deleteAdminUser',
    getAdminUserList: '/adminapi/sai/adminUserList',

    getMusicSubjectTypeList: '/adminapi/sai/getMusicSubjectTypeList',
    getSubjectTypeMusicTree: '/adminapi/sai/getSubjectTypeMusicTree',
    subjectTypeOption: '/adminapi/sai/subjectTypeOption',
    getSubjectMusicTreeList: '/adminapi/sai/subjectMusicTreeList',
    caiwuSaiquLogList: '/adminapi/sai/caiwuSaiquLogList',
    caiwuDanweiLogList: '/adminapi/sai/caiwuDanweiLogList',



    getHotelList: '/adminapi/sai/hotelList',
    deleteHotel: '/adminapi/sai/hotelDelete',
    setHotelRank: '/adminapi/sai/setHotelRank',
    setRoomRank: '/adminapi/sai/setRoomRank',
    editHotel: '/adminapi/sai/hotelEdit',
    addHotel: '/adminapi/sai/hotelAdd',
    getHotelDetail: '/adminapi/sai/hotelDetail',
    getHotelRoomList: '/adminapi/sai/roomList',
    addRoom: '/adminapi/sai/roomadd',
    editRoom: '/adminapi/sai/roomedit',
    deleteRoom: '/adminapi/sai/roomdelete',
    getRoomDetail: '/adminapi/sai/roomDetail',


    getShisuApplyList: '/adminapi/sai/shisuApplyList',
    editShisuRoomCount: '/adminapi/sai/editShisuRoomCount',
    clubSaiquList: '/adminapi/sai/clubSaiquList',
    clubSaiquDetail: '/adminapi/sai/clubSaiquDetail',
    clubSaiquEdit: '/adminapi/sai/clubSaiquEdit',
    editShisuAll: '/adminapi/sai/editShisuAll',
    setSaiquThird: '/adminapi/sai/setSaiquThird',
    getClubSaiquSetting: '/adminapi/sai/getClubSaiquSetting',
    setClubSaiquSetting: '/adminapi/sai/setClubSaiquSetting',

}

export default api

export function getScoreCaipanApplyList(parameter) {
    return axios({
        url: api.scoreCaipanApplyList,
        method: 'get',
        params: parameter
    })
}

export function editScoreCaipanApply(parameter) {
    return axios({
        url: api.editScoreCaipanApply,
        method: 'post',
        data: parameter
    })
}

export function getScoreCaipanApplyDetail(parameter) {
    return axios({
        url: api.scoreCaipanApplyDetail,
        method: 'get',
        params: parameter
    })
}

export function getSaijiList(parameter) {
  return axios({
    url: api.saijiList,
    method: 'get',
    params: parameter
  })
}

export function getSaijiDetail(parameter) {
  return axios({
    url: api.saijiDetail,
    method: 'get',
    params: parameter
  })
}

export function editSaiji(parameter) {
  return axios({
    url: api.editSaiji,
    method: 'post',
    data: parameter
  })
}



export function getSaiquList(parameter) {
    return axios({
        url: api.saiquList,
        method: 'get',
        params: parameter
    })
}
export function getSaiquCashList(parameter) {
    return axios({
        url: api.saiquCashList,
        method: 'get',
        params: parameter
    })
}

export function getSaiquRewardList(parameter) {
    return axios({
        url: api.saiquRewardList,
        method: 'get',
        params: parameter
    })
}

export function getSaiquDetail(parameter) {
    return axios({
        url: api.saiquDetail,
        method: 'get',
        params: parameter
    })
}
export function deleteSaiqu(parameter) {
    return axios({
        url: api.deleteSaiqu,
        method: 'get',
        params: parameter
    })
}

export function editSaiqu(parameter) {
    return axios({
        url: api.editSaiqu,
        method: 'post',
        data: parameter
    })
}


export function addSaiqu(parameter) {
    return axios({
        url: api.addSaiqu,
        method: 'post',
        data: parameter
    })
}




export function getDanweiList(parameter) {
    return axios({
        url: api.danweiList,
        method: 'get',
        params: parameter
    })
}

export function getDanweiUserList(parameter) {
    return axios({
        url: api.danweiUserList,
        method: 'get',
        params: parameter
    })
}

export function getDanweiOptions(parameter) {
    return axios({
        url: api.danweiOptions,
        method: 'get',
        params: parameter
    })
}

export function getDanweiDetail(parameter) {
    return axios({
        url: api.danweiDetail,
        method: 'get',
        params: parameter
    })
}

export function cashSaiqu(parameter) {
    return axios({
        url: api.cashSaiqu,
        method: 'get',
        params: parameter
    })
}
export function editDanwei(parameter) {
    return axios({
        url: api.editDanwei,
        method: 'post',
        data: parameter
    })
}

export function onSaiReward(parameter) {
    return axios({
        url: api.onSaiReward,
        method: 'post',
        data: parameter
    })
}
export function onSaiRewardAll(parameter) {
    return axios({
        url: api.onSaiRewardAll,
        method: 'post',
        data: parameter
    })
}
export function setRewardExtraPrice(parameter) {
    return axios({
        url: api.setRewardExtraPrice,
        method: 'post',
        data: parameter
    })
}
export function danweiDelete(parameter) {
    return axios({
        url: api.danweiDelete,
        method: 'post',
        data: parameter
    })
}

export function deleteDanweiUser(parameter) {
    return axios({
        url: api.deleteDanweiUser,
        method: 'post',
        data: parameter
    })
}

export function addDanweiUser(parameter) {
    return axios({
        url: api.addDanweiUser,
        method: 'post',
        data: parameter
    })
}


export function getApplyList(parameter) {
    return axios({
        url: api.applyList,
        method: 'get',
        params: parameter
    })
}

export function getApplyDetail(parameter) {
    return axios({
        url: api.applyDetail,
        method: 'get',
        params: parameter
    })
}
export function editApply(parameter) {
    return axios({
        url: api.editApply,
        method: 'post',
        data: parameter
    })
}



export function getApplySubjectList(parameter) {
    return axios({
        url: api.applySubjectList,
        method: 'get',
        params: parameter
    })
}

export function applySubjectDetail(parameter) {
    return axios({
        url: api.applySubjectDetail,
        method: 'get',
        params: parameter
    })
}
export function editApplySubject(parameter) {
    return axios({
        url: api.editApplySubject,
        method: 'post',
        data: parameter
    })
}


export function applyDelete(parameter) {
    return axios({
        url: api.applyDelete,
        method: 'post',
        data: parameter
    })
}


export function subjectOptions(parameter) {
    return axios({
        url: api.subjectOptions,
        method: 'get',
        params: parameter
    })
}
export function downloadAllCpCert(parameter) {
    return axios({
        url: api.downloadAllCpCert,
        method: 'get',
        params: parameter
    })
}

export function downloadAllJlCert(parameter) {
    return axios({
        url: api.downloadAllJlCert,
        method: 'get',
        params: parameter
    })
}

export function downloadAllLdCert(parameter) {
    return axios({
        url: api.downloadAllLdCert,
        method: 'get',
        params: parameter
    })
}

export function downloadAllCert(parameter) {
    return axios({
        url: api.downloadAllCert,
        method: 'get',
        params: parameter
    })
}
export function startListOptions(parameter) {
    return axios({
        url: api.startListOptions,
        method: 'get',
        params: parameter
    })
}
export function getStartList(parameter) {
    return axios({
        url: api.getStartList,
        method: 'get',
        params: parameter
    })
}
export function getLingduiList(parameter) {
    return axios({
        url: api.lingduiList,
        method: 'get',
        params: parameter
    })
}
export function getJiaolianList(parameter) {
    return axios({
        url: api.jiaolianList,
        method: 'get',
        params: parameter
    })
}
export function getCaipanList(parameter) {
    return axios({
        url: api.caipanList,
        method: 'get',
        params: parameter
    })
}
export function setYouxiu(parameter) {
    return axios({
        url: api.setYouxiu,
        method: 'post',
        data: parameter
    })
}

export function subjectMusicList(parameter) {
    return axios({
        url: api.subjectMusicList,
        method: 'get',
        params: parameter
    })
}
export function subjectMusicDetail(parameter) {
    return axios({
        url: api.subjectMusicDetail,
        method: 'get',
        params: parameter
    })
}
export function editSubjectMusic(parameter) {
    return axios({
        url: api.editSubjectMusic,
        method: 'post',
        data: parameter
    })
}
export function addSubjectMusic(parameter) {
    return axios({
        url: api.addSubjectMusic,
        method: 'post',
        data: parameter
    })
}
export function subjectMusicDelete(parameter) {
    return axios({
        url: api.subjectMusicDelete,
        method: 'post',
        params: parameter
    })
}


export function subjectTypeList(parameter) {
    return axios({
        url: api.subjectTypeList,
        method: 'get',
        params: parameter
    })
}
export function subjectTypeDetail(parameter) {
    return axios({
        url: api.subjectTypeDetail,
        method: 'get',
        params: parameter
    })
}
export function editSubjectType(parameter) {
    return axios({
        url: api.editSubjectType,
        method: 'post',
        data: parameter
    })
}
export function addSubjectType(parameter) {
    return axios({
        url: api.addSubjectType,
        method: 'post',
        data: parameter
    })
}
export function subjectTypeDelete(parameter) {
    return axios({
        url: api.subjectTypeDelete,
        method: 'post',
        params: parameter
    })
}



export function getSubjectMemberLimitList(parameter) {
    return axios({
        url: api.subjectMemberLimitList,
        method: 'get',
        params: parameter
    })
}
export function setSubjectMemberLimit(parameter) {
    return axios({
        url: api.setSubjectMemberLimit,
        method: 'post',
        data: parameter
    })
}
export function setSubjectTbMemberLimit(parameter) {
    return axios({
        url: api.setSubjectTbMemberLimit,
        method: 'post',
        data: parameter
    })
}
export function setSubjectAgeLimit(parameter) {
    return axios({
        url: api.setSubjectAgeLimit,
        method: 'post',
        data: parameter
    })
}
export function setAgeMixedSubjectLimit(parameter) {
    return axios({
        url: api.setAgeMixedSubjectLimit,
        method: 'post',
        data: parameter
    })
}
export function getSubjectMusicList(parameter) {
    return axios({
        url: api.subject2MusicList,
        method: 'get',
        params: parameter
    })
}
export function setSubjectMusic(parameter) {
    return axios({
        url: api.setSubjectMusic,
        method: 'post',
        data: parameter
    })
}
export function setSubjectsMusic(parameter) {
    return axios({
        url: api.setSubjectsMusic,
        method: 'post',
        data: parameter
    })
}
export function getSubjectTypeOptions(parameter) {
    return axios({
        url: api.getSubjectTypeOptions,
        method: 'get',
        params: parameter
    })
}
export function sjsqOptions(parameter) {
    return axios({
        url: api.sjsqOptions,
        method: 'get',
        params: parameter
    })
}
export function saiquOptions(parameter) {
    return axios({
        url: api.saiquOptions,
        method: 'get',
        params: parameter
    })
}
export function getApplyOrderDetail(parameter) {
    return axios({
        url: api.getApplyOrderDetail,
        method: 'get',
        params: parameter
    })
}
export function editApplyOrder(parameter) {
    return axios({
        url: api.editApplyOrder,
        method: 'post',
        data: parameter
    })
}
export function subjectDelete(parameter) {
    return axios({
        url: api.subjectDelete,
        method: 'post',
        data: parameter
    })
}
export function refreshOrder(parameter) {
    return axios({
        url: api.refreshOrder,
        method: 'post',
        data: parameter
    })
}


export function getSaiDateDetail(parameter) {
    return axios({
        url: api.getSaiDateDetail,
        method: 'post',
        data: parameter
    })
}
export function getTaskDetail(parameter) {
    return axios({
        url: api.getTaskDetail,
        method: 'post',
        data: parameter
    })
}
export function taskEdit(parameter) {
    return axios({
        url: api.taskEdit,
        method: 'post',
        data: parameter
    })
} 
export function taskAdd(parameter) {
    return axios({
        url: api.taskAdd,
        method: 'post',
        data: parameter
    })
} 
export function setTaskRank(parameter) {
    return axios({
        url: api.setTaskRank,
        method: 'post',
        data: parameter
    })
}
export function taskDelete(parameter) {
    return axios({
        url: api.taskDelete,
        method: 'post',
        data: parameter
    })
}
export function addSaiquApply(parameter) {
    return axios({
        url: api.addSaiquApply,
        method: 'post',
        data: parameter
    })
}
export function editSaiquApply(parameter) {
    return axios({
        url: api.editSaiquApply,
        method: 'post',
        data: parameter
    })
}
export function getSaiquApplyList(parameter) {
    return axios({
        url: api.getSaiquApplyList,
        method: 'get',
        params: parameter
    })
}
export function getSaiquApplyDetail(parameter) {
    return axios({
        url: api.getSaiquApplyDetail,
        method: 'get',
        params: parameter
    })
}
export function editDo(parameter) {
    return axios({
        url: api.editDo,
        method: 'post',
        data: parameter
    })
}



export function addSaiFile(parameter) {
    return axios({
        url: api.addSaiFile,
        method: 'post',
        data: parameter
    })
}

export function getSaiFileList(parameter) {
    return axios({
        url: api.saiFileList,
        method: 'get',
        params: parameter
    })
}

export function deleteSaiFile(parameter) {
    return axios({
        url: api.deleteSaiFile,
        method: 'post',
        data: parameter
    })
}


export function subjectTreeList(parameter) {
    return axios({
        url: api.subjectTreeList,
        method: 'get',
        params: parameter
    })
}

export function subjectTplTreeList(parameter) {
    return axios({
        url: api.subjectTplTreeList,
        method: 'get',
        params: parameter
    })
}
export function saveSubjectTree(parameter) {
    return axios({
        url: api.saveSubjectTree,
        method: 'post',
        data: parameter
    })
}



export function addXieyiFile(parameter) {
    return axios({
        url: api.addXieyiFile,
        method: 'post',
        data: parameter
    })
}
export function getXieyiList(parameter) {
    return axios({
        url: api.getXieyiList,
        method: 'post',
        data: parameter
    })
}



export function getRoomTypeList(parameter) {
    return axios({
        url: api.roomTypeList,
        method: 'get',
        params: parameter
    })
}

export function getCaiwuSaiquLogList(parameter) {
    return axios({
        url: api.caiwuSaiquLogList,
        method: 'get',
        params: parameter
    })
}

export function getCaiwuDanweiLogList(parameter) {
    return axios({
        url: api.caiwuDanweiLogList,
        method: 'get',
        params: parameter
    })
}


export function addRoomType(parameter) {
    return axios({
        url: api.addRoomType,
        method: 'post',
        data: parameter
    })
}

export function editRoomType(parameter) {
    return axios({
        url: api.editRoomType,
        method: 'post',
        data: parameter
    })
}
export function getRoomTypeDetail(parameter) {
    return axios({
        url: api.roomTypeDetail,
        method: 'get',
        params: parameter
    })
}

export function roomTypeDelete(parameter) {
    return axios({
        url: api.roomTypeDelete,
        method: 'post',
        data: parameter
    })
}


//酒店


// export function getHotelList(parameter) {
//     return axios({
//         url: api.hotelList,
//         method: 'get',
//         params: parameter
//     })
// }


// export function addHotel(parameter) {
//     return axios({
//         url: api.addHotel,
//         method: 'post',
//         data: parameter
//     })
// }

// export function editHotel(parameter) {
//     return axios({
//         url: api.editHotel,
//         method: 'post',
//         data: parameter
//     })
// }
// export function getHotelDetail(parameter) {
//     return axios({
//         url: api.hotelDetail,
//         method: 'get',
//         params: parameter
//     })
// }

// export function hotelDelete(parameter) {
//     return axios({
//         url: api.hotelDelete,
//         method: 'post',
//         data: parameter
//     })
// }

//交通

export function getBusList(parameter) {
    return axios({
        url: api.busList,
        method: 'get',
        params: parameter
    })
}


export function addBus(parameter) {
    return axios({
        url: api.addBus,
        method: 'post',
        data: parameter
    })
}

export function editBus(parameter) {
    return axios({
        url: api.editBus,
        method: 'post',
        data: parameter
    })
}
export function getBusDetail(parameter) {
    return axios({
        url: api.busDetail,
        method: 'get',
        params: parameter
    })
}

export function busDelete(parameter) {
    return axios({
        url: api.busDelete,
        method: 'post',
        data: parameter
    })
}


//站点

export function getStationList(parameter) {
    return axios({
        url: api.stationList,
        method: 'get',
        params: parameter
    })
}


export function addStation(parameter) {
    return axios({
        url: api.addStation,
        method: 'post',
        data: parameter
    })
}

export function editStation(parameter) {
    return axios({
        url: api.editStation,
        method: 'post',
        data: parameter
    })
}
export function getStationDetail(parameter) {
    return axios({
        url: api.stationDetail,
        method: 'get',
        params: parameter
    })
}

export function stationDelete(parameter) {
    return axios({
        url: api.stationDelete,
        method: 'post',
        data: parameter
    })
}

export function setConfrimStatus(parameter) {
    return axios({
        url: api.setConfrimStatus,
        method: 'post',
        data: parameter
    })
}

export function getConfrimApplyList(parameter) {
    return axios({
        url: api.getConfrimApplyList,
        method: 'get',
        params: parameter
    })
}

export function getTransApplyList(parameter) {
    return axios({
        url: api.getTransApplyList,
        method: 'get',
        params: parameter
    })
}


export function editTrans(parameter) {
    return axios({
        url: api.editTrans,
        method: 'post',
        data: parameter
    })
}

export function hotelOptions(parameter) {
    return axios({
        url: api.hotelOptions,
        method: 'get',
        params: parameter
    })
}
export function setHotel(parameter) {
    return axios({
        url: api.setHotel,
        method: 'post',
        data: parameter
    })
}
export function unSetHotel(parameter) {
    return axios({
        url: api.unSetHotel,
        method: 'post',
        data: parameter
    })
}
export function busgetImport(parameter) {
    return axios({
        url: api.busgetImport,
        method: 'post',
        headers: {
            'Content-Type':'multipart/form-data'
        },
        data: parameter
    })
}
export function busgoImport(parameter) {
    return axios({
        url: api.busgoImport,
        method: 'post',
        headers: {
            'Content-Type':'multipart/form-data'
        },
        data: parameter
    })
}
export function zhusuImport(parameter) {
    return axios({
        url: api.zhusuImport,
        method: 'post',
        data: parameter
    })
}
export function saiquApplyDelete(parameter) {
    return axios({
        url: api.saiquApplyDelete,
        method: 'post',
        data: parameter
    })
}
export function saiquXieyiDelete(parameter) {
    return axios({
        url: api.saiquXieyiDelete,
        method: 'post',
        data: parameter
    })
}

export function orderRefund(parameter) {
    return axios({
        url: api.orderRefund,
        method: 'post',
        data: parameter
    })
}

export function orderRefund2023(parameter) {
    return axios({
        url: api.orderRefund2023,
        method: 'post',
        data: parameter
    })
}
export function orderBuRefund(parameter) {
    return axios({
        url: api.orderBuRefund,
        method: 'post',
        data: parameter
    })
}

export function orderRefundApply(parameter) {
    return axios({
        url: api.orderRefundApply,
        method: 'get',
        params: parameter
    })
}

export function orderRefundRefuse(parameter) {
    return axios({
        url: api.orderRefundRefuse,
        method: 'get',
        params: parameter
    })
}
export function orderRefundRefuse2023(parameter) {
    return axios({
        url: api.orderRefundRefuse2023,
        method: 'get',
        params: parameter
    })
}
export function setBuPrice(parameter) {
    return axios({
        url: api.setBuPrice,
        method: 'post',
        data: parameter
    })
}
export function buOrderDelete(parameter) {
    return axios({
        url: api.buOrderDelete,
        method: 'post',
        data: parameter
    })
}

//执行官

export function getZhixingguanList(parameter) {
    return axios({
        url: api.zhixingguanList,
        method: 'get',
        params: parameter
    })
}


export function addZhixingguan(parameter) {
    return axios({
        url: api.addZhixingguan,
        method: 'post',
        data: parameter
    })
}

export function editZhixingguan(parameter) {
    return axios({
        url: api.editZhixingguan,
        method: 'post',
        data: parameter
    })
}
export function getZhixingguanDetail(parameter) {
    return axios({
        url: api.zhixingguanDetail,
        method: 'get',
        params: parameter
    })
}

export function zhixingguanDelete(parameter) {
    return axios({
        url: api.zhixingguanDelete,
        method: 'post',
        data: parameter
    })
}


//cca负责人

export function getCcarenList(parameter) {
    return axios({
        url: api.ccarenList,
        method: 'get',
        params: parameter
    })
}

export function getMiniCode(parameter) {
    return axios({
        url: api.getMiniCode,
        method: 'get',
        params: parameter
    })
}


export function addCcaren(parameter) {
    return axios({
        url: api.addCcaren,
        method: 'post',
        data: parameter
    })
}

export function editCcaren(parameter) {
    return axios({
        url: api.editCcaren,
        method: 'post',
        data: parameter
    })
}
export function getCcarenDetail(parameter) {
    return axios({
        url: api.ccarenDetail,
        method: 'get',
        params: parameter
    })
}

export function ccarenDelete(parameter) {
    return axios({
        url: api.ccarenDelete,
        method: 'post',
        data: parameter
    })
}




//裁判库
export function memberCaipanList(parameter) {
    return axios({
        url: api.memberCaipanList,
        method: 'get',
        params: parameter
    })
}
export function memberCaipanDetail(parameter) {
    return axios({
        url: api.memberCaipanDetail,
        method: 'get',
        params: parameter
    })
}
export function editMemberCaipan(parameter) {
    return axios({
        url: api.editMemberCaipan,
        method: 'post',
        data: parameter
    })
}
export function addMemberCaipan(parameter) {
    return axios({
        url: api.addMemberCaipan,
        method: 'post',
        data: parameter
    })
}
export function memberCaipanDelete(parameter) {
    return axios({
        url: api.memberCaipanDelete,
        method: 'post',
        params: parameter
    })
}


export function fapiaoApply(parameter) {
    return axios({
        url: api.fapiaoApply,
        method: 'post',
        data: parameter
    })
}

export function getKaipiaoItemList(parameter) {
    return axios({
        url: api.getKaipiaoItemList,
        method: 'post',
        data: parameter
    })
}

export function fapiaoShenqingApply(parameter) {
    return axios({
        url: api.fapiaoShenqingApply,
        method: 'post',
        data: parameter
    })
}

export function checkBaomingInfoOk(parameter) {
    return axios({
        url: api.checkBaomingInfoOk,
        method: 'post',
        data: parameter
    })
}

export function baomingImport(parameter) {
    return axios({
        url: api.baomingImport,
        method: 'post',
        data: parameter
    })
}

export function saiquRewardsSetting(parameter) {
    return axios({
        url: api.saiquRewardsSetting,
        method: 'post',
        data: parameter
    })
}

export function getCashDetail(parameter) {
    return axios({
        url: api.cashDetail,
        method: 'post',
        data: parameter
    })
}

export function cashEdit(parameter) {
    return axios({
        url: api.cashEdit,
        method: 'post',
        data: parameter
    })
}

export function zipHebing(parameter) {
    return axios({
        url: 'adminapi/sai/zipHebing',
        method: 'post',
        data: parameter
    })
}
export function addAdminUser(parameter) {
    return axios({
        url: 'adminapi/sai/addAdminUser',
        method: 'post',
        data: parameter
    })
}
export function deleteAdminUser(parameter) {
    return axios({
        url: 'adminapi/sai/deleteAdminUser',
        method: 'post',
        data: parameter
    })
}
export function getAdminUserList(parameter) {
    return axios({
        url: 'adminapi/sai/adminUserList',
        method: 'post',
        data: parameter
    })
}

export function getVisitData(parameter) {
    return axios({
        url: 'adminapi/sai/getVisitData',
        method: 'post',
        data: parameter
    })
}
 
export function getMusicSubjectTypeList(parameter) {
    return axios({
        url: 'adminapi/sai/getMusicSubjectTypeList',
        method: 'post',
        data: parameter
    })
}
export function getSubjectTypeMusicTree(parameter) {
    return axios({
        url: 'adminapi/sai/getSubjectTypeMusicTree',
        method: 'post',
        data: parameter
    })
}
export function subjectTypeOption(parameter) {
    return axios({
        url: 'adminapi/sai/subjectTypeOption',
        method: 'post',
        data: parameter
    })
}
export function getSubjectMusicTreeList(parameter) {
    return axios({
        url: 'adminapi/sai/subjectMusicTreeList',
        method: 'post',
        data: parameter
    })
}
export function deleteSubjectTypeMusic(parameter) {
    return axios({
        url: 'adminapi/sai/deleteSubjectTypeMusic',
        method: 'post',
        data: parameter
    })
}
export function fapiaoImport(parameter) {
    return axios({
        url: 'adminapi/sai/fapiaoImport',
        method: 'post',
        data: parameter
    })
}



export function getHotelList(parameter) {
    return axios({
        url: api.getHotelList,
        method: 'post',
        data: parameter
    })
}
export function deleteHotel(parameter) {
    return axios({
        url: api.deleteHotel,
        method: 'post',
        data: parameter
    })
}
export function setHotelRank(parameter) {
    return axios({
        url: api.setHotelRank,
        method: 'post',
        data: parameter
    })
}
export function setRoomRank(parameter) {
    return axios({
        url: api.setRoomRank,
        method: 'post',
        data: parameter
    })
}
export function editHotel(parameter) {
    return axios({
        url: api.editHotel,
        method: 'post',
        data: parameter
    })
}
export function addHotel(parameter) {
    return axios({
        url: api.addHotel,
        method: 'post',
        data: parameter
    })
}
export function getHotelDetail(parameter) {
    return axios({
        url: api.getHotelDetail,
        method: 'post',
        data: parameter
    })
}
export function getHotelRoomList(parameter) {
    return axios({
        url: api.getHotelRoomList,
        method: 'post',
        data: parameter
    })
}
export function addRoom(parameter) {
    return axios({
        url: api.addRoom,
        method: 'post',
        data: parameter
    })
}
export function editRoom(parameter) {
    return axios({
        url: api.editRoom,
        method: 'post',
        data: parameter
    })
}
export function deleteRoom(parameter) {
    return axios({
        url: api.deleteRoom,
        method: 'post',
        data: parameter
    })
}
export function getRoomDetail(parameter) {
    return axios({
        url: api.getRoomDetail,
        method: 'post',
        data: parameter
    })
} 
export function getShisuApplyList(parameter) {
    return axios({
        url: api.getShisuApplyList,
        method: 'post',
        data: parameter
    })
}
export function editShisuRoomCount(parameter) {
    return axios({
        url: api.editShisuRoomCount,
        method: 'post',
        data: parameter
    })
}
export function getClubSaiquDetail(parameter) {
    return axios({
        url: api.clubSaiquDetail,
        method: 'post',
        data: parameter
    })
}
export function clubSaiquEdit(parameter) {
    return axios({
        url: api.clubSaiquEdit,
        method: 'post',
        data: parameter
    })
}

export function editShisuAll(parameter) {
    return axios({
        url: api.editShisuAll,
        method: 'post',
        data: parameter
    })
}

export function getClubSaiquList(parameter) {
    return axios({
        url: api.clubSaiquList,
        method: 'get',
        params: parameter
    })
}
export function setSaiquThird(parameter) {
    return axios({
        url: api.setSaiquThird,
        method: 'get',
        params: parameter
    })
}

export function getClubSaiquSetting(parameter) {
    return axios({
        url: api.getClubSaiquSetting,
        method: 'get',
        params: parameter
    })
}
export function setClubSaiquSetting(parameter) {
    return axios({
        url: api.setClubSaiquSetting,
        method: 'get',
        params: parameter
    })
}